<template>
  <div class="involvement-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <doughnut-chart
      v-if="isLoaded"
      :chart-data="dataBarSet"
      :options="lineOptions"
      class="inAge-content__chart"
      :height="350"
    ></doughnut-chart>
    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.audit.thematics.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { DoughnutChart } from "../../../../../../../../components/charts";

  // mixins
  import inThemeTonal from "../../../../../../../../mixins/chart/inThemeTonal"
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import inAgeConfig from "../../../../../../../../config/inAgeConfig";

  // moment
  import moment from 'moment';

  export default {
    name: "InAgeBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        age: inThemeTonal,
        chartId: "InThemeTonal",
        format: "DD.MM.YYYY",
        showLabel: true,
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    computed: {
      chartDate() {
        return this.$store.getters.getAuditPeriod(this.chartName);
      },
      isLoaded() {
        return this.$store.getters.isAuditLoaded(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
    },
    mixins: [
      inThemeTonal,
      saveImage
    ],
    components: {
      DoughnutChart
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .inAge-content__chart {
    margin-bottom: 10px;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
</style>
